<template>
  <div class="link-block">
    <div class="link-block-value">
      <AvatarIcon :icon="icon"></AvatarIcon>
    </div>
    <TitleSection :title="title" :subtitle="subtitle"> </TitleSection>
  </div>
</template>

<script>
export default {
  name: "LinkCard",

  props: ["icon", "title", "subtitle"],
};
</script>

<style lang="scss" scoped>
.link-block {
  display: flex;
  align-items: center;

  &-value {
    font-weight: 300;
    font-size: 46px;
    margin-right: 15px;
    color: #2c3153;
  }
}
</style>
